export default __webpack_public_path__ + "static/media/contact_us.8c35852e.jpg";